export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  gaId: "G-7Q0RK19B20",
  gaIdAnett: "G-GNWZTXR2SL",
  gaIdClient: "G-19M03B0XTP"
};
